<template>
  <div class="container">
    <div class="list-container f-column-b">
      <div class="list-header">
        <h3 class="title">{{ isSearch ? "搜索结果" : cateInfo.name }}</h3>
      </div>
      <div class="info-list f-column-b">
        <ul v-if="list.length">
          <li v-for="(item, index) in list" :key="index" class="info-item" @click="viewItem(item)">
            <span class="point" />
            <span class="flex-1 text-cut ml-20 title-txt">{{ item.title }}</span>
            <span class="ml-40 color-999">{{ item.releaseTime }}</span>
          </li>
        </ul>
        <no-data v-else />
      </div>
    </div>
    <info-pagination
      :total="total"
      :current-page.sync="curPage"
      :page-size="pageSize"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import noticeApi from "@/api/newnotice"
import { parseTime } from "@/filters";
import NoData from "@/components/NoData.vue";
import InfoPagination from "@/components/InfoPagination.vue";

export default {
  name: "InfoList",
  components: {
    InfoPagination,
    NoData
  },
  props: {
    cateInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      title: "",
      curPage: 1,
      pageSize: 15,
      total: 0,
      list: [],
      path:""
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["activeMenuId"]),
    isSearch() {
      return this.$route.query && Object.prototype.hasOwnProperty.call(this.$route.query, "title")
    }
  },
  watch: {
    cateInfo() {
      this.title = ""
      this.getList("0")
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.path = this.$route.path
    this.title = this.$route.query.title || ""
    this.getList()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    // 获取列表
    getList() {
      noticeApi.page({
        pageNo: this.curPage,
        pageSize: this.pageSize,
        columnId: this.cateInfo.id,
        title: this.title,
        systemType:this.path.indexOf("zbcg")>-1?'ZBCG':'CQJY',
        noticeType:this.path.indexOf("cjgg")>-1?'CJGG':'BGGG',
      }).then(res => {
        if (res.code === 0) {
          const data = res.data || {}
          const list = data.list || []
          this.total = data.total
          list.forEach(item => {
            item.releaseTime = parseTime(item.fbstartDate, "{y}-{m}-{d}")
          })
          this.list = data.list
        }
      })
    },
    // 翻页
    handleCurrentChange(val) {
      this.curPage = val
      this.getList()
    },
    // 行点击
    viewItem(item) {
      this.$router.push({
        name: "noticeDetail",
        query: {
          id: item.id
        }
      })
    }
  }
};
</script>

<style scoped lang="scss">
  .list-container{
    border: 1px solid #ddd;
    padding: 0 20px;
    min-height: 800px;
    .list-header{
      height: 60px;
      line-height: 60px;
      border-bottom: 2px solid #ddd;
      .title{
        font-size: 24px;
        color: $--color-primary;
        position: relative;
        &::after{
          content: '';
          width: 96px;
          height: 2px;
          background-color: $--color-primary;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
    }
    .info-list{
      flex: 1;
      min-height: 0;
      padding-bottom: 10px;
      .info-item{
        height: 50px;
        display: flex;
        align-items: center;
        cursor: pointer;
        border-bottom: 1px solid #ddd;
        &:hover{
          .title-txt{
            color: $--color-primary;
          }
        }
        &:last-child{
          border: none;
        }
        .point{
          width: 5px;
          height: 5px;
          background-color: $--color-primary;
        }
      }
    }
  }
</style>
